"use client";

import React, { useState } from "react";
import { useRouter } from "next/navigation";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export function PromptModal({pageType}) {
  const [open, setOpen] = useState(true);
  const router = useRouter();
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-[729px] rounded-[20px] p-0 [&>button:last-of-type]:hidden">
        <DialogHeader>
          <DialogDescription>
            {/* "bg-slate-400 */}
            <div className="relative rounded-[20px] p-0">
                <button
                    className="absolute right-[32px] top-[32px] p-0 m-0 border-none bg-transparent outline-none hover:opacity-80"
                    onClick={() => setOpen(false)}
                    aria-label="Close"
                    >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 18 18"
                        fill="none"
                    >
                        <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2.17051 0.751156C1.80054 0.381186 1.2007 0.381186 0.830731 0.751156C0.46076 1.12113 0.46076 1.72096 0.830731 2.09094L7.70022 8.96042L0.830731 15.83C0.46076 16.1999 0.46076 16.7997 0.830731 17.1697C1.2007 17.5397 1.80054 17.5397 2.17051 17.1697L9.04 10.3002L15.9094 17.1697C16.2795 17.5397 16.8793 17.5397 17.2493 17.1697C17.6193 16.7997 17.6193 16.1999 17.2493 15.83L10.3798 8.96042L17.2493 2.09094C17.6193 1.72096 17.6193 1.12113 17.2493 0.751156C16.8793 0.381186 16.2795 0.381186 15.9094 0.751156L9.04 7.62064L2.17051 0.751156Z"
                        fill="#0E1941"
                        />
                    </svg>
                </button>

                 <div className="p-[102px_67px_68px] md:p-[60px_30px_30px]">
                    <h3 className=" text-[30px] font-medium text-[#0E1941] mb-[30px] text-center leading-[45px]">
                     Was your plan purchased on or after February 2, 2025?
                    </h3>
                      <div className="flex flex-row gap-4 sm:gap-6 justify-center mb-[30px] flex-wrap">
                        <button
                          className="w-[178px] sm:w-[178px] bg-[#ED7766] h-[45px] rounded-[50px] text-[17px] flex items-center justify-center text-[#0E1941]"
                          onClick={() => {                            
                            if (pageType === "warrantySupport") {
                              router.push("/allstate-protection");
                            }
                            setOpen(false);
                          }}
                          aria-label="Close"
                        >
                          Yes
                        </button>
                        
                        <button
                          className="w-[178px] sm:w-[178px] bg-[#D9EEFF] h-[45px] rounded-[50px] text-[17px] flex items-center justify-center text-[#0E1941]"
                          onClick={() => {     
                            if (pageType === "allstateProtection") {
                              router.push("/warranty-support");
                            }                      
                            setOpen(false);
                          }}
                          aria-label="Close"
                        >
                          No
                        </button>
                      </div>

                      <p className="text-[#0E1941] text-[14px] leading-[22px] text-center">
                          Plans purchased before February 2, 2025 will continue to be serviced
                          by Epic.
                      </p>
                  </div>
            </div>
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="sm:justify-start" />
      </DialogContent>
    </Dialog>
  );
}
